import React, { useState, useEffect } from "react";
import "./style.scss";
import Spinner from "../spinner/Spinner";
import checkout_icon from "../../assets/icons/checkoutCom.svg";
import paypal_icon from "../../assets/icons/paypal_icon_blue.svg";
import coinPaymentIcon from "../../assets/icons/coinpaymentsIcon.svg";
import checkoutIcon from "../../assets/icons/checkout_icon.svg";
import nuvei from "../../assets/icons/nuveis.svg";
import { applyCoupon } from "../../utils/apis/payment";
import { useDispatch, useSelector } from "react-redux";
import { returnErrors } from "../../utils/store/reducers/Error";
import { Checkbox, ConfigProvider } from "antd";
import moment from "moment";
import crossIcon from "../../assets/icons/crossIconsRed.svg";
import nace from "../../assets/icons/nace_favicon.png";
import { FormatUSD } from "../../utils/helpers/string";

const RePaymentModal = ({
  open,
  setOpen,
  setPayload,
  payload,
  handleSubmit,
  size,
  id,
  isLoading,
  initialAmount,
  heading = "Re-Payment",
  isCoupon = true,
  items,
  isQualifiedAndZeroPlan = false,
  activeTab,
  today,
}) => {
  const [couponCode, setCouponCode] = useState("");
  const [couponError, setCouponError] = useState("");
  const [load, setLoad] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const dispatch = useDispatch();
  const { idToken } = useSelector((state) => state.auth);
  const [resetCheckBoxOne, setResetCheckBoxOne] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [resetCheckBoxTwo, setResetCheckBoxTwo] = useState(false);
  const [showWarningTwo, setShowWarningTwo] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const paymentMethods = [
    ...(heading !== "Market Data Subscription" &&
    heading !== "Switch Subscription"
      ? [
          {
            method: "Checkout",
            value: "checkout",
            icon: checkout_icon,
          },
        ]
      : []),
    ...(heading !== "Rebill"
      ? [
          {
            method: "Nuvei",
            value: "nuvei",
            icon: nuvei,
          },
        ]
      : []),
    ...(heading !== "Market Data Subscription" &&
    heading !== "Switch Subscription"
      ? [
          {
            method: "Coinpayments",
            value: "coinpayment",
            icon: coinPaymentIcon,
          },
        ]
      : []),
  ];

  const filteredPaymentMethods =
    payload === "coinpayment" || payload?.payment_method === "coinpayment"
      ? paymentMethods.filter((item) => item.value === "coinpayment")
      : payload === "checkout" || payload?.payment_method === "checkout"
        ? paymentMethods.filter((item) => item.value === "checkout")
        : paymentMethods;

  const { data } = useSelector((state) => state.accountMetrics.plans);
  const activeAccount = data?.find((item) => {
    return Number(item.login_id) === Number(id);
  });

  const handleApplyCode = async () => {
    if (!couponCode) {
      setCouponError("The coupon code should not be empty.");
      return;
    }
    try {
      setLoad(true);
      const res = await applyCoupon(id, couponCode, idToken, "reset");
      setLoad(false);
      if (res) {
        setPayload((prev) => ({
          ...prev,
          promo: res.coupon_applied,
        }));
        setPaymentInfo(res);
      }
    } catch (error) {
      setLoad(false);
      setCouponCode("");
      setPayload((prev) => ({
        ...prev,
        promo: "",
      }));
      setPaymentInfo(null);
      dispatch(
        returnErrors(
          (error.response?.data.detail === "Not found."
            ? "Invalid Coupon"
            : error.response?.data.detail) || "Something went wrong.",
          error.response?.status,
        ),
      );
    }
  };

  useEffect(() => {
    setResetCheckBoxOne(false);
    setShowWarning(false);
    setShowWarningTwo(false);
    setResetCheckBoxTwo(false);
    if (items?.login_id) {
      setPayload((prev) => ({ ...prev, account_id: items.login_id }));
    }
  }, [open]);

  const handleResetCheckBoxOne = (e) => {
    setResetCheckBoxOne(e.target.checked);
    if (e.target.checked) {
      setShowWarning(false);
    }
  };

  const handleResetCheckBoxTwo = (e) => {
    setResetCheckBoxTwo(e.target.checked);
    if (e.target.checked) {
      setShowWarningTwo(false);
    }
  };

  const removedCoupon = () => {
    setCouponCode("");
    setCouponError("");
    setPayload((prev) => ({ ...prev, promo: null }));
    setPaymentInfo(null);
  };

  return open ? (
    <div className="repayment-modal-overlay">
      <div className="repayment-modal-container">
        <div
          className="overflow-container"
          style={
            !isCoupon && !initialAmount
              ? { height: "auto", minHeight: "auto" }
              : {}
          }
        >
          <div className="repayment-heading">
            <p>{heading}</p>
            <span onClick={handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="8.4"
                  stroke="white"
                  strokeWidth="1.2"
                />
                <path
                  d="M16 8L8 16"
                  stroke="white"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 8L16 16"
                  stroke="white"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
          <div className="payment-container">
            <p>Payment Method</p>
            <div className="payment-methods">
              {filteredPaymentMethods.map((item, index) => (
                <div
                  key={index}
                  className={`grayButton ${
                    item?.value === payload.payment_method && "selected"
                  }`}
                  onClick={() =>
                    setPayload((pre) => ({
                      ...pre,
                      payment_method: item.value,
                    }))
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    width: filteredPaymentMethods.length === 1 ? "100%" : "50%",
                  }}
                >
                  <img src={item.icon} alt="" height="100%" />
                  <p>{item.method}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="coupon_container">
            <div className="x">
              {isCoupon && (
                <>
                  <div className="flexColumn">
                    <p className="challengeTitle">Reset Fee</p>
                  </div>
                  <div className="couponWrapper">
                    <input
                      placeholder="Coupon"
                      type="text"
                      value={couponCode}
                      onChange={(e) => {
                        setCouponCode(e.target.value?.toUpperCase());
                        setCouponError("");
                      }}
                      onBlur={() => setCouponError("")}
                      disabled={paymentInfo?.discount}
                    />
                    <div
                      className={`button_container repayment ${
                        paymentInfo?.discount ? "applied" : load && "pending"
                      }`}
                    >
                      <button
                        onClick={handleApplyCode}
                        disabled={load || paymentInfo?.discount}
                      >
                        {load ? (
                          <Spinner size={20} stroke={2} />
                        ) : paymentInfo === null ? (
                          "Apply code"
                        ) : (
                          "Applied"
                        )}
                      </button>
                      {paymentInfo?.discount && !load && (
                        <span
                          onClick={removedCoupon}
                          className="removed_coupon"
                        >
                          <img src={crossIcon} alt="crossIcon" />
                        </span>
                      )}
                    </div>
                  </div>
                  {couponError && <p className="error">{couponError}</p>}
                  <div className="flexSpacebetween discountSection">
                    <p>Discount</p>
                    <span>${paymentInfo?.discount || 0}</span>
                  </div>
                </>
              )}
              {(paymentInfo?.final_price || initialAmount) && (
                <div
                  className="flexSpacebetween priceSection"
                  style={{ border: !isCoupon && "none" }}
                >
                  <span>Total Price</span>
                  <span>
                    {FormatUSD(paymentInfo?.final_price || initialAmount)}
                  </span>
                </div>
              )}
              {heading !== "Market Data Subscription" && isCoupon && (
                <div className="confirmation_msg terms_checkbox">
                  <ConfigProvider
                    theme={{ token: { colorPrimaryHover: "none" } }}
                  >
                    <Checkbox
                      checked={resetCheckBoxOne}
                      onChange={handleResetCheckBoxOne}
                    >
                      {items?.trading_platform === 1
                        ? "AlphaTicks"
                        : items?.trading_platform === 2
                          ? "Tradovate/Ninja"
                          : items?.trading_platform}{" "}
                      Account {items?.account_name} will be reset
                    </Checkbox>
                    {!isQualifiedAndZeroPlan && (
                      <Checkbox
                        checked={resetCheckBoxTwo}
                        onChange={handleResetCheckBoxTwo}
                      >
                        Your rebill date is{" "}
                        {moment(items?.expiry_date).format("DD-MM-YYYY")},
                        resets DO NOT affect this date
                      </Checkbox>
                    )}
                  </ConfigProvider>
                  {(showWarning ||
                    (isQualifiedAndZeroPlan ? false : showWarningTwo)) && (
                    <p style={{ color: "red" }}>
                      Please check the required checkbox before making a
                      payment.
                    </p>
                  )}
                </div>
              )}
              <div className="flexCenter">
                <button
                  className="standard-button width50"
                  onClick={() => {
                    // When coupon/checkbox flow is disabled, submit directly
                    if (!isCoupon || heading === "Market Data Subscription") {
                      handleSubmit();
                    } else if (!resetCheckBoxOne) {
                      setShowWarning(true);
                      setShowWarningTwo(false);
                    } else if (
                      isQualifiedAndZeroPlan ? false : !resetCheckBoxTwo
                    ) {
                      setShowWarning(false);
                      setShowWarningTwo(true);
                    } else {
                      setShowWarning(false);
                      setShowWarningTwo(false);
                      handleSubmit();
                    }
                  }}
                  disabled={isLoading}
                >
                  {isLoading ? <Spinner size={20} /> : "Make Payment"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default RePaymentModal;
